// extracted by mini-css-extract-plugin
export default {"container":"Placeholder_container__6s8w4","stack":"Placeholder_stack__WrDXy"};